import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import "./ModelListingScreen.css";

function ModelListingScreen() {
  return <Row id="homeScreenModel"></Row>;
}

export default ModelListingScreen;
